import { SeasonEnum, seasonToString } from '@app/enums/SeasonEnum';

const MIN_R = 13;
const MAX_R = 20;

export const reviewsSeasonCats = (season?: SeasonEnum) => {
  const result = [];

  if (season === SeasonEnum.winter) {
    result.push({
      title: 'Шипованные шины',
      href: `/catalog/tyres/thorn/${seasonToString(season)}/`,
    });
    result.push({
      title: 'Фрикционные шины',
      href: `/catalog/tyres/friction-tyres/${seasonToString(season)}/`,
    });
  }

  return result;
};

export const reviewsBrandCats = (brandName: string, brandUrl: string, season?: SeasonEnum) => {
  const result = [];

  result.push({
    title: `Шины ${brandName}`,
    href: `/catalog/tyres/${brandUrl}/`,
  });

  if (season === null || season === SeasonEnum.summer) {
    result.push({
      title: `Летние шины ${brandName}`,
      href: `/catalog/tyres/${brandUrl}/leto/`,
    });
  }

  if (season === null || season === SeasonEnum.winter) {
    result.push({
      title: `Зимние шины ${brandName}`,
      href: `/catalog/tyres/${brandUrl}/zima/`,
    });
  }

  if (season === null || season === SeasonEnum.winter) {
    result.push({
      title: `Шипованные шины ${brandName}`,
      href: `/catalog/tyres/thorn/${brandUrl}/`,
    });
    result.push({
      title: `Фрикционные шины ${brandName}`,
      href: `/catalog/tyres/friction-tyres/${brandUrl}/`,
    });
  }

  return result;
};

export const reviewsSeasonR = (season: SeasonEnum, allSizesLink = false) => {
  const links = [];
  for (let i = MIN_R; i <= MAX_R; i++) {
    links.push({
      title: `R${i}`,
      href: `/catalog/tyres/r${i}/${seasonToString(season)}`,
    });
  }

  if (allSizesLink) {
    links.push({
      title: 'Все размеры',
      href: `/catalog/tyres/${seasonToString(season)}/`,
    });
  }

  return links;
};

export const reviewsBrandR = (brandName: string, brandUrl: string, season?: SeasonEnum, allSizesLink = false) => {
  const links = [];
  for (let i = MIN_R; i <= MAX_R; i++) {
    links.push({
      title: `R${i}`,
      href: season ? `/catalog/tyres/${brandUrl}/r${i}/${seasonToString(season)}/` : `/catalog/tyres/${brandUrl}/r${i}/`,
    });
  }

  if (allSizesLink) {
    links.push({
      title: 'Все размеры',
      href: season !== null ? `/catalog/tyres/${brandUrl}/${seasonToString(season)}/` : `/catalog/tyres/${brandUrl}/`,
    });
  }

  return links;
};
